/**
 * Sprint T-18 · Notification Studio · Playground · Action bar.
 *
 * Dry Run · Test Send (Q2=a strict self) · Save to history.
 * All three call the same backend endpoints; only outcome differs.
 */
import React from "react";
import { toast } from "sonner";
import { Loader2, Zap, Send, Save } from "lucide-react";

export default function PlaygroundActionBar({
  disabled,
  currentUser,
  onDryRun,
  onTestSend,
  onSaveHistory,
  isRendering,
  isTestSending,
  isSaving,
  lastOutcome,
}) {
  const myEmail = currentUser?.email;
  const canTestSend = Boolean(myEmail) && !disabled;

  return (
    <div
      className="flex flex-wrap items-center gap-2 rounded border border-[var(--ag-border)] bg-[var(--ag-panel)] p-3"
      data-testid="studio-playground-action-bar"
    >
      <button
        type="button"
        disabled={disabled || isRendering}
        onClick={onDryRun}
        data-testid="studio-playground-dry-run-btn"
        className="flex items-center gap-1.5 rounded border border-[var(--ag-border)] px-3 py-1.5 text-xs text-[var(--ag-text)] hover:border-[var(--ag-gold)]/50 disabled:cursor-not-allowed disabled:opacity-40"
      >
        {isRendering ? <Loader2 size={12} className="animate-spin" /> : <Zap size={12} />}
        Dry Run
      </button>

      <button
        type="button"
        disabled={!canTestSend || isTestSending}
        onClick={() => {
          if (!myEmail) {
            toast.error("No hay email de superadmin logueado");
            return;
          }
          onTestSend?.(myEmail);
        }}
        data-testid="studio-playground-test-send-btn"
        className="flex items-center gap-1.5 rounded border border-emerald-500/60 bg-emerald-500/10 px-3 py-1.5 text-xs text-emerald-200 hover:bg-emerald-500/20 disabled:cursor-not-allowed disabled:opacity-40"
      >
        {isTestSending ? <Loader2 size={12} className="animate-spin" /> : <Send size={12} />}
        Test Send → {myEmail || "—"}
      </button>

      <button
        type="button"
        disabled={disabled || isSaving}
        onClick={onSaveHistory}
        data-testid="studio-playground-save-history-btn"
        className="flex items-center gap-1.5 rounded border border-[var(--ag-border)] px-3 py-1.5 text-xs text-[var(--ag-text-dim)] hover:border-[var(--ag-gold)]/50 hover:text-[var(--ag-text)] disabled:cursor-not-allowed disabled:opacity-40"
      >
        {isSaving ? <Loader2 size={12} className="animate-spin" /> : <Save size={12} />}
        Save to History
      </button>

      {lastOutcome && (
        <span
          className={`ml-auto rounded px-2 py-0.5 font-mono text-[10px] ${
            lastOutcome === "sent"
              ? "bg-emerald-500/20 text-emerald-300"
              : lastOutcome === "invalid_template" || lastOutcome === "failed"
              ? "bg-rose-500/20 text-rose-300"
              : "bg-amber-500/20 text-amber-300"
          }`}
          data-testid="studio-playground-last-outcome"
        >
          {lastOutcome}
        </span>
      )}
    </div>
  );
}
